export default [
  {
    path: '/setting/lamp',
    component: () => import('@/views/setting/lamp.vue'),
    name: 'setting.lamp',
    meta: {
      title: '辅助指示器',
    },
    hidden: true,
  },
];
